module.exports = __webpack_public_path__ + "static/img/24a.48d1e07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/24a.jpg
// module id = x6I9
// module chunks = 0